// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalFilter-root-znhZ6 {
  padding: 25px;
}

.ModalFilter-cancelBtn-LO6kE {
  display: inline-block;
  color: var(--primary-link-foreground) !important;
  text-decoration: none !important;
  cursor: pointer;
  margin-right: 30px;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Transaction/ModalFilter/ModalFilter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".root {\n  padding: 25px;\n}\n\n.cancelBtn {\n  display: inline-block;\n  color: var(--primary-link-foreground) !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  margin-right: 30px;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ModalFilter-root-znhZ6`,
	"cancelBtn": `ModalFilter-cancelBtn-LO6kE`
};
module.exports = ___CSS_LOADER_EXPORT___;
